import React from "react";

export const CreateInvoiceIcon = ({ width = 24, height = 24, color = "black" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 13.34C20.37 13.12 19.7 13 19 13V5H5V18.26L6 17.6L9 19.6L12 17.6L13.04 18.29C13 18.5 13 18.76 13 19C13 19.65 13.1 20.28 13.3 20.86L12 20L9 22L6 20L3 22V3H21V13.34ZM18 15V18H15V20H18V23H20V20H23V18H20V15H18Z" fill={color}/>
    </svg>
  );
};

